module.exports = __webpack_public_path__ + "img/mobile_map_genova.f6bdf62c.svg";